export default "__VITE_ASSET__DAE1G_TV__"